import Vue from 'vue';
import querystring from 'querystring';
import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
import * as Articulos from '@lib/Articulos';
import { Publicacion } from '@lib/Web/Publicaciones';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { ResumenPublicacionesMercadoLibre } from '@/__env/lib/MercadoLibre/Publicaciones/Resumen';


export class ControladorSeccion
{

    constructor()
    {
//        this.Estadistica = new ResumenEstadisticas( this );
    }

    //public readonly Estadistica: ResumenEstadisticas;
    public readonly Buscador: Buscador = new Buscador();
    public Seleccionados: Publicacion[] = [];

    Iniciar()
    {
        this.Buscador.Iniciar();
    }


    Abrir( x: Publicacion )
    {
        if ( x && x.Existe )
        {
            window.open( x.URL );
         //   router.push( '/mercadolibre/publicacion/' + x.Id );
        }
    }

    AbrirEnOtraPestaña( x: Publicacion )
    {
        if ( x && x.Existe )
        {
            window.open( '/#/mercadolibre/publicacion/' + x.Id );
        }
    }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica= new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista extends VistaBase
{
    public Filtros: FiltrosBase = new FiltrosBase();
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Publicacion[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null, agregar: boolean = false )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        if ( !agregar )
        {
            this.Items.clear();
            this.Estado = 'cargando';
        }

        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        ff.details = 'articulo';
        let e = await Publicacion.find( ff );
        if ( e.Error )
        {
            this.Estado = 'error';
        }
        else
        {
            if ( !agregar )
            {
                this.Items = e.Items;
            } else
            {
                this.Items.push( ...e.Items );
            }

            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Estado: 0,
        Tipo: 0,
        TiposArticulo: 0,
        Limite: 1,
        Orden: 1,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        EnvioGratis: 0,
    };


    public get Estados() { return [{ Nombre: 'Activas', Id: 'activa' }, { Nombre: 'Pausada', Id: 'pausada' }]  }
    public get Tipos() { return Publicaciones.Tipos.Filter; }
    public get TiposArticulo() { return Articulos.Tipos.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get EnvioGratis() { return [{ Nombre: 'Indistinto', Id: '' }, { Nombre: 'Con envio gratis', Id: 'S' }, { Nombre: 'Sin envio gratis', Id: 'N' }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices() { return [{ Nombre: 'Titulo', Id: 'titulo' }, { Nombre: 'Id', Id: 'id' }, { Nombre: 'Artículo', Id: 'codigo' }, { Nombre: 'Alfabetico', Id: 'titulo' }, { Nombre: 'Importe', Id: 'precio' }, { Nombre: 'Stock', Id: 'stock' }, { Nombre: 'Ventas', Id: 'ventas' }]; }
    
    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.EnvioGratis > 0 )
            {
                a.push( { Nombre: this.EnvioGratis[this.Valores.EnvioGratis].Nombre, Eliminar: () => { this.Valores.EnvioGratis = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Tipo > 0 )
            {
                a.push( { Nombre: this.Tipos[this.Valores.Tipo].Nombre, Eliminar: () => { this.Valores.Tipo = 0; this.Buscador.Buscar(); } } );
            }


            if ( this.Valores.TiposArticulo > 0 )
            {
                a.push( { Nombre: this.TiposArticulo[this.Valores.TiposArticulo].Nombre, Eliminar: () => { this.Valores.TiposArticulo = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Cuenta  > 0)
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Id;
            }

            if ( this.Valores.EnvioGratis > 0 )
            {
                filtro.envio_gratis = this.EnvioGratis[this.Valores.EnvioGratis].Id;
            }

            if ( this.Valores.Tag > 0 )
            {
                filtro.tags = this.Tags[this.Valores.Tag].Id;
            }



            if ( this.Valores.Tipo > 0 )
            {
                filtro.tipo = this.Tipos[this.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.TiposArticulo > 0 )
            {
                filtro.tipo_articulo = this.TiposArticulo[this.Valores.TiposArticulo].Valor.map( x => x.Id ).join( ',' );
            }

            if ( this.Valores.Cuenta > 0 )
            {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }

        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.tag )
        {
            this.Valores.Tag = 0;
            let idx = this.Tags.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.tag );
            if ( idx > 0 ) this.Valores.Tag= idx;
        }

        if ( filtro.tipo )
        {
            this.Valores.Tipo = 0;
            let idx = this.Tipos.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo );
            if ( idx > 0 ) this.Valores.Tipo = idx;
        }

        if ( filtro.tipo_articulo )
        {
            this.Valores.TiposArticulo = 0;
            let idx = this.TiposArticulo.findIndex( x => x.Nombre.toLowerCase().eliminar( ' ' ) == filtro.tipo_articulo );
            if ( idx > 0 ) this.Valores.TiposArticulo = idx;
        }

        if ( filtro.cuenta )
        {
             this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }

        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Tag > 0 )
        {
            filtro.tag = this.Tags[this.Valores.Tag].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Valores.Tipo > 0 )
        {
            filtro.tipo = this.Tipos[this.Valores.Tipo].Nombre.eliminar( ' ' ).toLowerCase();


        }

        if ( this.Valores.TiposArticulo > 0 )
        {
            filtro.tipo_articulo = this.TiposArticulo[this.Valores.TiposArticulo].Nombre.eliminar( ' ' ).toLowerCase();


        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}




const Controlador = new ControladorSeccion();
export { Controlador };

